import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import Breadcrumbs from '@pelckmans/elementis/components/breadcrumbs';
import { useContext } from 'react';
import ModuleContext from '../../_contexts/ModuleContext';

export default function SuperModuleBreadcrumb() {
  const { module } = useContext(ModuleContext);

  if (!module) return null;

  return (
    <Breadcrumbs.Item
      avatarImage={module.styling?.logo ? <AvatarImage name={module.name} src={module.styling?.logo} /> : undefined}
    >
      {module.catalogName}
    </Breadcrumbs.Item>
  );
}
